import React from 'react'
import { Link, Redirect } from 'react-router-dom'
import { Modal } from 'react-bootstrap'
import { config } from '../Config/config'
import DetailDoctorService from '../Service/DetailDoctorService'
import DoctorTreatmentService from '../Service/doctorTreatmentService'
import Tindakan from './tambahTindakan'
import Spesialis from './tambahSpesiaslisasi'


export default class DoctorProfile extends React.Component {
    constructor() {
        super()
        this.state = {
            bioList: [],
            listSP:[],
            treatList: [],
            eduList: [],
            histList: [],
            locList: [],
            dokter_id: [],
            ShowModalfunc: false,
            data: {
                id_doctor: "",
                spesialis: ""
            },
        }
    }

    loadList = async () => {
        const responID = await DetailDoctorService.getID(localStorage.getItem(config.biodata_id))
        if (responID.success) {
            this.setState({
                dokter_id: responID.result
            })
            {
                this.state.dokter_id.map(data => {
                    this.setState({
                        data : {
                            ...this.state.data,
                            id_doctor : data._id
                        }
                    })
                })
            }
        }
        const responSP = await DetailDoctorService.getSP()
        if (responSP.success) {
            this.setState({
                listSP : responSP.result
            })
        }

        const responBio = await DetailDoctorService.getProfile(this.state.data)
        if (responBio.success) {
            this.setState({
                bioList: responBio.result,
            })
            {
                this.state.bioList.map(data => {
                    this.setState({
                        image : data.image,
                        data : {
                            ...this.state.data,
                            spesialis : data.sp
                        }
                    })
                })
            }
        }

        const responTreat = await DetailDoctorService.getTreatment(this.state.data)
        if (responTreat.success) {
            this.setState({
                treatList: responTreat.result,
            })
        }

        const responEdu = await DetailDoctorService.getEducation(this.state.data)
        if (responEdu.success) {
            this.setState({
                eduList: responEdu.result,
            })
        }

        const responHist = await DetailDoctorService.getHistory(this.state.data)
        if (responHist.success) {
            this.setState({
                histList: responHist.result
            })

            {
                //     this.state.histList.map(data => {
                //         this.setState({
                //             locParent: this.state.locParent.concat([data.locParent])
                //         })

                //     })
            }
        }

        const responLoc = await DetailDoctorService.getLokasi(this.state.data)
        if (responHist.success) {
            this.setState({
                locList: responLoc.result
            })
        }
    }

    componentDidMount() {
        this.loadList()
    }

    expandHandler = () => {
        const { textJadwal, icon } = this.state

        if (textJadwal == "Lihat") {
            this.setState({
                textJadwal: "Sembunyikan",
                icon: "fa fa-caret-up"
            })
        } else {
            this.setState({
                textJadwal: "Lihat",
                icon: "fa fa-caret-down"
            })
        }

    }
    noneHandler = () => {
        this.setState({
            ShowModalfunc: true
        })
    }
    
    cancelHandler = () => {
        this.setState({
            ShowModalfunc: false
        })
    }


    render() {
        const { treatList, eduList, histList, ShowModalfunc,
            locParent, locList, bioList,listSP} = this.state
        const { test, dokter, setShowPhoto,updPhoto, 
            href,handleUpload,imagehandle, progress,
            editPhoto,cancelPhoto, errors, ModelBio} = this.props
        return (
            <div>
            <div class="card-box profile-header">
                {/* {JSON.stringify(this.state.listSP)} */}

                <div class="row">
                    <div class="col-md-12">
                        <div class="profile-view" style={{ margin: 30 }}>

                            <div class="row">
                                <div class="col-md-4">
                                    <div class="profile-info container" style={{ marginBottom: 10, padding: 10 }}>
                                        <div class="row">
                                            <div class="profile-img">

                                                <button class="btn btn-link" style={{ padding: 0 }} onClick={editPhoto}>
                                                    <h5 style={{ textAlign: 'right' }}><i class="fa fa-pencil"></i>
                                                    </h5><img class="avatar" src={ModelBio.image_path} alt="" />
                                                </button>


                                            </div>

                                        </div>
                                        {
                                            this.state.bioList.map(data => {
                                                return (
                                                    <div>
                                                        <h4 class="text-primary" style={{ textAlign: 'center', marginTop: 30 }}>
                                                            {data.fullname}</h4>
                                                        <h5 style={{ textAlign: 'center' }}>
                                                            {data.sp}</h5>
                                                        <img class="mx-auto d-block" style={{ height: 25 }} src="assets/img/star.png" alt="" />
                                                    </div>
                                                )
                                            })
                                        }
                                        <div class="profile-about" style={{ borderLeft: 0, borderRight: 0, borderRadius: 0, paddingBottom: 0 }}>
                                            <button class="btn btn-link" onClick={this.noneHandler}><h4 class="text-primary" style={{ marginTop: 5 }}>Janji</h4></button>
                                        </div>
                                        <div class="profile-about" style={{ borderLeft: 0, borderRight: 0, borderRadius: 0, paddingBottom: 0 }}>
                                            <button class="btn btn-link" onClick={this.noneHandler}><h4 class="text-primary" style={{ marginTop: 5 }}>Obrolan / Konsultasi</h4></button>
                                        </div>


                                    </div>
                                    <div class="profile-info">
                                        <div class="profile-about" style={{ backgroundColor: '#00FFFF', paddingLeft: 15, paddingTop:15, paddingBottom: 10}}>
                                            <h4>Tentang Saya</h4>
                                        </div>

                                        <div style={{ padding: 15 }}>
                                            <h4 class="text-primary">Tindakan Medis</h4>
                                            <p style={{ padding: 10 }}>
                                                <div class="text">
                                                    {treatList.map(data => {
                                                        return (
                                                            <h5>- {data.name}</h5>
                                                        )
                                                    })}
                                                </div>
                                            </p>

                                            <h4 class="text-primary">Riwayat Praktek</h4>
                                            <p style={{ padding: 10 }}>
                                                <div class="text">
                                                    {histList.map(data => {
                                                        return (
                                                            <tbody>
                                                                <tr>
                                                                    <td><h5>{data.namaRS}, {data.parent}</h5></td>
                                                                </tr>
                                                                <tr>
                                                                    <td><h6 style={{ marginLeft: 10 }}>{data.spesialis}</h6></td>

                                                                    <td><h6 style={{ textAlign: 'right' }}>{data.tCreate}-{data.ket}</h6></td>
                                                                </tr>
                                                            </tbody>
                                                        )

                                                    })}
                                                </div>
                                            </p>

                                            <h4 class="text-primary">Pendidikan</h4>
                                            <p>
                                                <div class="text">
                                                    {eduList.map(data => {
                                                        return (
                                                            <tbody>
                                                                <tr>
                                                                    <td class="col-md-12"><h5>{data.institution_name}</h5></td>
                                                                </tr>
                                                                <tr>
                                                                    <td class="col=md-6"><h6 style={{ marginLeft: 20 }}>{data.major}</h6></td>
                                                                    <td class="col-md-6"><h6>{data.end_year}</h6></td>
                                                                </tr>
                                                            </tbody>
                                                        )
                                                    })}
                                                </div>
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-8">
                                    <div class="profile-info profile-tabs">
                                        <ul class="nav nav-tabs nav-tabs-bottom profile-info" style={{border: 0}}>
                                            <li class="nav-item"><a class="nav-link show" href="#spesialisasi" data-toggle="tab">Spesialisasi</a></li>
                                            <li class="nav-item"><a class="nav-link show active" href="#tindakan" data-toggle="tab">Tindakan</a></li>
                                            <li class="nav-item"><a class="nav-link show" href="#aktivitas" data-toggle="tab">Aktivitas</a></li>
                                            <li class="nav-item"><a class="nav-link show" href="#konsultasi" data-toggle="tab">Konsultasi</a></li>
                                            <li class="nav-item"><a class="nav-link show" href="#pengaturan" data-toggle="tab">Pengaturan</a></li>
                                        </ul>

                                        <div class="tab-content" style={{height: 500}}>
                                        {/* <div class="tab-pane show active" id="spesialisasi"> */}
                                        <div class="tab-pane show" id="spesialisasi">
                                                <Spesialis
                                                  list_sp={this.state.listSP}
                                                />
                                            </div>
                                            <div class="tab-pane show active" id="tindakan">
                                                {/* Tindakan */}
                                                <Tindakan
                                                treatList={this.state.treatList}
                                                idDoctor = {this.state.data.id_doctor}
                                                idTindakan = {this.state.data.id}
                                                />
                                            </div>
                                            <div class="tab-pane show" id="aktivitas">
                                                Tab Aktivitas
                                            </div>
                                            <div class="tab-pane show" id="konsultasi">
                                                Tab Konsultasi
                                            </div>
                                            <div class="tab-pane show" id="pengaturan">
                                                Tab Pengaturan
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="edit_photo">
                    <Modal show={setShowPhoto} >
                        <Modal.Header>
                            <Modal.Title>Edit Photo</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div class="form-group">
                                <label>File</label>
                                <input type="file" class="form-control-file" onChange={imagehandle} />
                                <span className="error"> {errors["photo"]}</span>
                            </div>
                            <div class="progress">
                                <div class="progress-bar bg-success" role="progressbar" style={{ width: (parseInt(progress) + "%") }}></div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <button type="button" class="btn btn-primary" onClick={handleUpload} >Upload</button>
                            <button type="button" class="btn btn-primary" onClick={updPhoto} >Save</button>
                            <button type="button" class="btn btn-secondary" onClick={cancelPhoto} >Cancel</button>
                        </Modal.Footer>
                    </Modal>
                </div>
                <div class="mb-10">
                <Modal show={ShowModalfunc} onHide={this.cancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>Pemberitahuan</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <div class="modal-body text-center hapus">
                            <img src="assets/img/sent.png" alt="" width="50" height="46" />
                            <p> </p>
                            <p>Maaf, Fungsi belum tersedia. </p>
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <button type="button" class="btn btn-light" onClick={this.cancelHandler}>Kembali</button>
                    </Modal.Footer>
                </Modal>
            </div>
            </div>
        )
    }
}